import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { colors, gradients, shadows, borderRadius, typography, mixins } from './theme';

// Temel container bileşenleri
export const PageContainer = styled.div`
  min-height: 100vh;
  background: ${gradients.hero};
  position: relative;
  overflow: hidden;
`;

export const ContentContainer = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  padding: 2rem;
  position: relative;
  z-index: 2;
`;

// Grid arkaplan
export const GridBackground = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: linear-gradient(rgba(50, 50, 255, 0.1) 1px, transparent 1px),
    linear-gradient(90deg, rgba(50, 50, 255, 0.1) 1px, transparent 1px);
  background-size: 50px 50px;
  opacity: 0.5;
`;

// Başlık bileşenleri
export const Title = styled.h1`
  font-size: ${typography.sizes['4xl']};
  font-weight: ${typography.weights.extrabold};
  color: ${colors.white};
  margin-bottom: 1.5rem;
  line-height: ${typography.lineHeights.tight};
  
  @media (max-width: 768px) {
    font-size: ${typography.sizes['3xl']};
  }
`;

export const Subtitle = styled.p`
  font-size: ${typography.sizes.lg};
  color: ${colors.gray};
  margin-bottom: 2rem;
  line-height: ${typography.lineHeights.relaxed};
  
  @media (max-width: 768px) {
    font-size: ${typography.sizes.base};
  }
`;

// Buton bileşenleri
export const PrimaryButton = styled(Link)`
  ${mixins.flexCenter}
  padding: 0.8rem 2rem;
  background: ${gradients.primary};
  color: ${colors.white};
  font-weight: ${typography.weights.semibold};
  border-radius: ${borderRadius.full};
  text-decoration: none;
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: ${shadows.primary};
  }
`;

export const SecondaryButton = styled(PrimaryButton)`
  background: ${gradients.glass.light};
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);

  &:hover {
    background: ${gradients.glass.hover};
    box-shadow: ${shadows.secondary};
  }
`;

// Kart bileşenleri
export const Card = styled.div`
  ${mixins.glass}
  padding: 2rem;
  border-radius: ${borderRadius.lg};
  color: ${colors.white};
`;

export const GradientCard = styled(Card)`
  background: ${props => props.gradient || gradients.card.purple};
  border: none;
`;

// Form bileşenleri
export const Input = styled.input`
  width: 100%;
  padding: 0.8rem 1.2rem;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: ${borderRadius.md};
  color: ${colors.white};
  font-size: ${typography.sizes.base};
  transition: all 0.3s ease;

  &:focus {
    outline: none;
    border-color: ${colors.primary};
    background: rgba(255, 255, 255, 0.15);
  }

  &::placeholder {
    color: rgba(255, 255, 255, 0.5);
  }
`;

export const TextArea = styled(Input).attrs({ as: 'textarea' })`
  min-height: 120px;
  resize: vertical;
`;

// Animasyon keyframeler
export const fadeIn = `
  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

export const float = `
  @keyframes float {
    0% { transform: translateY(0px); }
    50% { transform: translateY(-20px); }
    100% { transform: translateY(0px); }
  }
`;

export const gradientMove = `
  @keyframes gradientMove {
    0% { background-position: 0% 50%; }
    50% { background-position: 100% 50%; }
    100% { background-position: 0% 50%; }
  }
`; 